import { Tooltip, TooltipProps } from "@mui/material";
import React from "react";

// export default function OptionalToolTip(     {tooltip, children}): {children: (React.ReactElement<never, any> & ReactElement<any, string | JSXElementConstructor<any>>) | (React.ReactElement<never, any> & string) | (React.ReactElement<never, any> & number) | React.ReactElement<never, any> | (React.ReactElement<never, any> & ReactNodeArray) | (React.ReactElement<never, any> & ReactPortal) | (React.ReactElement<never, any> & boolean) | (React.ReactElement<never, any> & null) | (React.ReactElement<never, any> & undefined)}

const OptionalToolTip = ({
  tooltip,
  children,
  placement,
}: {
  tooltip?: string | null;
  children?: React.ReactNode;
  placement?: TooltipProps["placement"];
}): JSX.Element => {
  return tooltip ? (
    <Tooltip title={tooltip} placement={placement || "right"} arrow>
      <span>{children}</span>
    </Tooltip>
  ) : (
    <span>{children}</span>
  );
};

export default OptionalToolTip;
